import {
	NgModule,
	inject
} from '@angular/core';

import {
	RouterModule,
	Routes
} from '@angular/router';

import {
	Dd1pndsNgErrorComponent
} from 'dd1pnds-ngx-libs';

import {
	RoutesConfig
} from './configs/routes.config';

import {
	LandingPageAvvcComponent
} from './features/landing-page-avvc/landing-page-avvc.component';

import {
	AvvcAccessGuardService
} from './shared/services/avvc-access-guard.service';

const routesNames = RoutesConfig.routeNames;

const headerRoutes = [];

const applicationRoutes: Routes = [{
	path: routesNames.accueil,
	component: LandingPageAvvcComponent,
	canActivate: [() => inject(AvvcAccessGuardService).canActivate()],
	pathMatch: 'full'
}];

export const routes: Routes = [{
	path: routesNames.error404,
	component: Dd1pndsNgErrorComponent
}, {
	path: routesNames.error500,
	component: Dd1pndsNgErrorComponent
}, {
	path: routesNames.errorForteAffluence,
	component: Dd1pndsNgErrorComponent
}, {
	path: routesNames.errorInactivite,
	component: Dd1pndsNgErrorComponent
}, {
	path: routesNames.errorSessionExpiree,
	component: Dd1pndsNgErrorComponent
},
...headerRoutes,
...applicationRoutes,
{
	//Else -> 404
	path: '**',
	redirectTo: routesNames.error404
}];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'enabledBlocking',
			scrollPositionRestoration: 'enabled',
			anchorScrolling: 'enabled'
		})
	],
	exports: [
		RouterModule
	]
})

export class AppRoutingModule { }
